export default __webpack_public_path__ + "static/media/new-12.3258f3f7.png";